module.exports = __webpack_public_path__ + "img/img_guang@2x.d6a9d2aa.png";